module.exports = __webpack_public_path__ + "static/media/SmartPageIcon.b49fd3bf.png";